import Header from "Dashboard/components/Header";
import { ResourceChargesPreview } from "./components/ResourceChargesPreview";
import { FuelPreview } from "./components/FuelPreview";
import { GotPaidPreview } from "./components/GotPaidPreview";
import { StockExemptionPreview } from "./components/StockExemptionPreview";
import { StockInputPreview } from "./components/StockInputPreview";
import { RegistrationPreview } from "./components/RegistrationPreview";
import { ResourcesPreview } from "./components/ResourcesPreview";
import { ServicePreview } from "./components/ServicePreview";
import { StatisticPreview } from "./components/StatisticsPreview";
import { ConsumablesPreview } from "./components/ConsumablesPreview";
import { Toolbox } from "./components/Toolbox";
import { WePaidPreview } from "./components/WePaidPreview";
import "./styles/main.scss";

const Index = () => {
  return (
    <>
      <Header title="Dnevna tabla" />
      <Toolbox />
      <main id="dnevnaTabla">
        <ResourcesPreview />
        <ServicePreview />
        <RegistrationPreview />
        <StockInputPreview />
        <GotPaidPreview />
        <StatisticPreview />
        <ResourceChargesPreview />
        <FuelPreview />
        <ConsumablesPreview />
        <StockExemptionPreview />
        <WePaidPreview />
        <div className="daily-table-line1 dottedLine"></div>
        <div className="daily-table-line2 dottedLine"></div>
        <div className="daily-table-line3 dottedLine"></div>
      </main>
    </>
  )
};

export default Index;
